import { isString } from "lodash";
import { MuiOtpInput, MuiOtpInputProps } from "mui-one-time-password-input";
import React from "react";
import { Control, FieldValues, Path, useController } from "react-hook-form";
import { Box, FormHelperText } from "@mui/material";
import { cn } from "@/src/shared/utils/mergeTwClasses";

interface OtpFieldProps<T extends FieldValues> extends MuiOtpInputProps {
  control: Control<T>;
  name: Path<T>;
  disabled?: boolean;
  withoutW?: boolean;
}

export function matchIsNumeric(text: unknown) {
  return isString(text) && /^\d+$/.test(text);
}

export const OtpField = <T extends FieldValues>({
  control,
  name,
  length = 5,
  disabled = false,
  withoutW = false,
  ...rest
}: OtpFieldProps<T>) => {
  const {
    field: { onChange, value = "", ref },
    fieldState: { error },
  } = useController({ control, name });

  return (
    <Box className="flex flex-col gap-1">
      <Box className="gap-4 flex-center-row">
        {!withoutW && (
          <MuiOtpInput
            TextFieldsProps={{
              // autoComplete: "OTP-field",
              disabled: true,
              placeholder: "0",
              sx: {
                maxWidth: 47,
                "& .MuiFilledInput-root": {
                  height: 40,
                },
                "& .MuiFilledInput-root .MuiInputBase-input": {
                  padding: "0px !important",
                },
              },
            }}
            className={cn(!!error && "[&_.MuiOtpInput-TextField>*]:border-red")}
            value={"W"}
            length={1}
          />
        )}
        <MuiOtpInput
          TextFieldsProps={{
            autoComplete: "one-time-code",
            disabled,
            placeholder: "0",
            sx: {
              maxWidth: 47,
              "& .MuiFilledInput-root": {
                height: 40,
              },
              "& .MuiFilledInput-root .MuiInputBase-input": {
                padding: "0px !important",
              },
            },
            type: "number",
            inputProps: {
              className:
                "[appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none",
              inputMode: "numeric",
              pattern: "[0-9]*",
            },
          }}
          className={cn(!!error && "[&_.MuiOtpInput-TextField>*]:border-red")}
          onChange={onChange}
          value={value}
          ref={ref}
          validateChar={matchIsNumeric}
          length={length}
          sx={{
            gap: "16px",
          }}
          {...rest}
        />
      </Box>
      {error && (
        <FormHelperText error>{error.message}</FormHelperText>
      )}
    </Box>
  );
};
